// extracted by mini-css-extract-plugin
export default {"content":"StyledWMDialog_content__beqZn"};